// extracted by mini-css-extract-plugin
export default {"content":"Layout_content__UOgH6","contentLayoutForCreation":"Layout_contentLayoutForCreation__Art4K"};